//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { createFieldConfig, Store } from '../../components/QSelectUtils'
import ItemsSearchField from '../../components/Field/ItemsSearchField.vue'
import { formatRegradingDiffForTool, formatAmount, getToolRegradingRecords, amountDiffTypes, regradingTypes, formatFieldAmountDiffRegrading, getValueFieldAmountDiffRegrading, onInputAmountReal, formatFieldDiffAmount, units, formatUniqueToolName } from './stockInventoryTools.js'
import ReportMaterialsImageBtn from '../Report/ReportMaterials/ReportMaterialsImageBtn.vue'

export default {
  components: {
    ItemsSearchField,
    ReportMaterialsImageBtn
  },
  props: {
    record: {
      type: Object,
      required: true
    },
    toolRecord: {
      type: Object,
      default: null
    },
    regradingRecordInput: {
      type: Object,
      default: () => {}
    },
    regradingRecords: {
      type: Array,
      default: null
    },
    toolRecords: {
      type: Array,
      default: null
    }
  },
  data: function () {
    const vm = this

    return {
      formatFieldAmountDiffRegrading: formatFieldAmountDiffRegrading,
      getValueFieldAmountDiffRegrading: getValueFieldAmountDiffRegrading,
      formatFieldDiffAmount: formatFieldDiffAmount,
      formatRegradingDiffForTool: formatRegradingDiffForTool,
      onInputAmountReal: onInputAmountReal,
      formatUniqueToolName: formatUniqueToolName,
      units: units,
      regradingRecord: {
        id: null,
        toolA: this.toolRecord && this.toolRecord.tool,
        toolB: null,
        amountDiff: null,
        amountDiffType: null,
        regradingType: null,
        toolARecordId: this.toolRecord && this.toolRecord.id,
        toolBRecordId: null
      },
      toolRecordB: { amountReal: null },
      loading: false,
      getToolRegradingRecords: getToolRegradingRecords,
      regradingTypeFieldConfig: createFieldConfig({ allRecordsFn: this.getRegradingTypes }),

      toolRecordsSearchConfig: createFieldConfig(
        new Store({
          fullReadable: false,
          cached: false,
          searchable: true,
          searchValueMinLength: 0,
          searchFiltrationBySource: true,
          proxy: {
            urlBase: '/service/delta/stockInventory/task/tools?splitByParties=true',
            post: true,
            searchParamKey: 'searchPattern',
            filterType: 'stockInventoryTool',
            formId: 'stockInventoryTaskRegarding',
            get urlParams () {
              const params = {}
              if (vm.record.request.stock) {
                params.stockId = vm.record.request.stock.id
              }
              if (vm.record.request.id && vm.record.request.id != -1) {
                params.requestId = vm.record.request.id
              }
              params.sourceListType = 'selected'

              return params
            },
            get bodyParams () {
              const params = {}

              const toolIds = vm.toolRecords.map(toolRecord => toolRecord.tool && toolRecord.tool.id || null).filter(toolId => toolId != null)
              params.ids = toolIds
              const uniqueKeys = vm.toolRecords.map(toolRecord => toolRecord.tool && toolRecord.tool.uniqueKey || null).filter(uniqueKey => uniqueKey != null)
              params.uniqueKeys = uniqueKeys

              // Исключаем номенклатуру, с которой делаем пересортицу
              params.excludeUniqueKeys = []
              if (vm.regradingRecord.toolA && vm.regradingRecord.toolA.uniqueKey) {
                params.excludeUniqueKeys.push(vm.regradingRecord.toolA && vm.regradingRecord.toolA.uniqueKey)
              }

              // Исключаем номенклатуру, с которой уже есть другая пересортица с этой же позицией
              const toolARegradingRecords = getToolRegradingRecords(vm.toolRecord, vm.regradingRecords) || []
              params.excludeUniqueKeys.push(
                ...toolARegradingRecords.map(regradingRecord => regradingRecord.toolB && regradingRecord.toolB.uniqueKey).filter(uniqueKey => uniqueKey != null)
              )

              // Исключаем уникальную номенклатуру, у которой уже есть пересортица
              params.excludeUniqueKeys.push(
                ...vm.toolRecords
                  .filter(toolRecord => {
                    const regradingRecords = getToolRegradingRecords(toolRecord, vm.regradingRecords) || []
                    const uniqueTool = toolRecord.tool && (toolRecord.tool.serialNumber || toolRecord.tool.inventoryNumber)
                    console.log(toolRecord.tool.name, uniqueTool, regradingRecords.length)
                    return uniqueTool && regradingRecords.length >= 1
                  })
                  .map(toolRecord => toolRecord.tool && toolRecord.tool.uniqueKey)
                  .filter(uniqueKey => uniqueKey != null)
              )

              // Исключаем номенклатуру, которая удалена или нет withdrawTime
              params.excludeUniqueKeys.push(
                ...vm.toolRecords.filter(toolRecord => toolRecord.removed || !!toolRecord.withdrawTime).map(toolRecord => toolRecord.tool && toolRecord.tool.uniqueKey || null).filter(uniqueKey => uniqueKey != null)
              )
              return params
            },
            mapper: tool => {
              const toolRecord = vm.toolRecords.find(tR => tR.tool && tR.tool.uniqueKey === tool.uniqueKey)
              return {
                ...tool,
                amountReal: toolRecord && toolRecord.amountReal,
                _disabled: vm.toolRecord && vm.toolRecord.unit && vm.toolRecord.unit !== tool.unit,
                _reasonDisabled: 'Несоответствует единица измерения'
              }
            }
          }
        }))
    }
  },
  computed: {
    request: function () {
      return this.record.request
    },
    addition: function () {
      return !this.regradingRecordInput || this.regradingRecordInput.id == null
    },
    toolRecordColumns: function () {
      return this.getToolRecordsColumns()
    },
    filteredRegradingRecords: function () {
      let filteredRegradingRecords = this.regradingRecords && this.regradingRecords.filter(r => !r.removed) || []
      if (this.toolRecord) {
        filteredRegradingRecords = filteredRegradingRecords.filter(r => r.toolARecordId === this.toolRecord.id)
      }

      return filteredRegradingRecords
    },
    newRegradingRecords: function () {
      const newRegradingRecords = JSON.parse(JSON.stringify(this.regradingRecords.filter(r => !r.removed) || []))

      if (this.regradingRecordInput) {
        const index = newRegradingRecords.findIndex(r => r.id === this.regradingRecordInput.id)
        if (index !== -1) {
          newRegradingRecords.splice(index, 1)
        }
      }

      if (this.regradingRecord.toolARecordId && this.regradingRecord.toolBRecordId) {
        newRegradingRecords.push(this.regradingRecord)
      }

      return newRegradingRecords
    },
    mobile: function () {
      return this.$store.getters.getUser.view === 'mobile'
    }
  },
  created: function () {
    if (!this.addition && this.regradingRecordInput) {
      this.regradingRecord.id = this.regradingRecordInput.id
      this.regradingRecord.toolARecordId = this.regradingRecordInput.toolARecordId
      this.regradingRecord.toolA = this.regradingRecordInput.toolA
      this.regradingRecord.toolBRecordId = this.regradingRecordInput.toolBRecordId
      this.regradingRecord.toolB = this.regradingRecordInput.toolB
      this.regradingRecord.amountDiff = this.regradingRecordInput.amountDiff
      this.regradingRecord.amountDiffType = this.regradingRecordInput.amountDiffType
      this.regradingRecord.regradingType = this.regradingRecordInput.regradingType
    }

    if (this.regradingRecord.toolBRecordId) {
      this.toolRecordB = JSON.parse(JSON.stringify(this.toolRecords.find(tR => tR.id === this.regradingRecord.toolBRecordId)))
    }
  },
  methods: {
    onInputAmountDiff: function (val) {
      if (!val) {
        this.regradingRecord.amountDiffType = null
      } else if (val > 0) {
        this.regradingRecord.amountDiffType = amountDiffTypes.find(type => type.id === 'surplus')
      } else {
        this.regradingRecord.amountDiffType = amountDiffTypes.find(type => type.id === 'shortfall')
      }

      const regradingTypes = this.getRegradingTypes()
      if (this.regradingRecord.regradingType && !regradingTypes.some(regradingType => regradingType.id === this.regradingRecord.regradingType.id)) {
        this.regradingRecord.regradingType = null
      }
    },
    onInputToolB: function (toolB) {
      if (toolB) {
        this.toolRecord.unit = toolB.unit
        if (this.toolRecords.some(tR => tR.tool && tR.tool.uniqueKey === toolB.uniqueKey)) {
          this.toolRecordB = JSON.parse(JSON.stringify(this.toolRecords.find(tR => tR.tool && tR.tool.uniqueKey === toolB.uniqueKey)))
          this.regradingRecord.toolBRecordId = this.toolRecordB && this.toolRecordB.id
        }
      } else {
        this.toolRecord.unit = null
        this.toolRecordB = {}
        this.regradingRecord.toolBRecordId = null
      }
    },
    onSave: async function () {
      const fields = ['amountDiffRegradingA', 'toolBAmountReal', 'toolB', 'amountDiffRegradingB', 'toolAAmountReal', 'toolAUnit', 'amountDiff', 'regradingType']
      let valid = true
      fields.forEach(field => {
        valid = this.$refs[field].validate() && valid
      })

      if (valid) {
        this.$emit('save', this.regradingRecord, this.toolRecordB)
      }
    },
    onClose: function () {
      this.$emit('close')
    },
    getRegradingTypes: function () {
      return this.regradingRecord.amountDiffType && regradingTypes.filter(regradingType => regradingType.amountDiffType === this.regradingRecord.amountDiffType.id) || []
    },
    getToolRecordsColumns: function () {
      const columns = [
        {
          name: 'name',
          label: 'Наименование номенклатурной позиции',
          labelTable: 'Наименование</br>номенклатурной</br>позиции',
          defaultWidth: 300,
          sortable: true
        },
        {
          name: 'amount',
          label: 'Остаток на данном складе (1С)',
          labelTable: 'Остаток</br>на данном</br>складе (1С)',
          defaultWidth: 80,
          sortable: true,
          format: formatAmount
        },
        {
          name: 'amountReal',
          label: 'Фактическое количество',
          labelTable: 'Фактическое</br>количество',
          defaultWidth: 80,
          format: formatAmount,
          sortable: true
        },
        {
          name: 'unit',
          label: 'Единица измерения',
          labelTable: 'Единица</br>измерения',
          defaultWidth: 70,
          sortable: false
        },
        {
          name: 'key',
          label: 'ID номенклатурной позиции в 1С',
          labelTable: 'ID номенклатурной</br>позиции в 1С',
          defaultWidth: 140,
          sortable: false
        },
        {
          name: 'partyName',
          label: 'Наименование партии',
          sortable: true
        },
        {
          name: 'serialNumber',
          label: 'Серийный номер',
          labelTable: 'Серийный</br>номер',
          sortable: false
        },
        {
          name: 'inventoryNumber',
          label: 'Инвентарный номер',
          labelTable: 'Инвентарный</br>номер',
          sortable: false
        },
        {
          name: 'nomType',
          label: 'Тип номенклатуры',
          labelTable: 'Тип</br>номен-</br>клатуры',
          defaultWidth: 80,
          sortable: true
        },
        {
          name: 'nomVid',
          label: 'Вид номенклатуры',
          labelTable: 'Вид</br>номенклатуры',
          defaultWidth: 130,
          sortable: true
        },
        {
          name: 'nomAffilation',
          label: 'Принадлежность номенклатуры',
          labelTable: 'Принадлежность</br>номенклатуры',
          defaultWidth: 110,
          sortable: true
        }]

      return this.prepareColumns(columns)
    },
    prepareColumns: function (columns) {
      for (const column of columns) {
        if (!column.field) {
          column.field = column.name
        }
        if (!column.align) {
          column.align = 'left'
        }
        if (column.sortable == null) {
          column.sortable = false
        }
      }
      return columns.filter(column => {
        return !this.mobile || !column.mobileHidden
      })
    }
  }
}

